module.exports = __webpack_public_path__ + "img/14_juillet.bf498c5.jpg";